import { ref, computed } from "vue";

const cart = ref([]);
const compId = ref('')
compId.value = localStorage.getItem("CompanyId")

export function useCart() {
  // Load cart from localStorage
  const loadCart = () => {
    const stored = localStorage.getItem("moduleCart");
    cart.value = stored ? JSON.parse(stored) : [];
  };

  // Total number of items
  const itemCount = computed(() => cart.value.length);

  // Add or update
  const addToCart = (module) => {
    
    const newItem = {
      moduleid: module.id,
      modulename: module.name,
      companyid: compId.value,
      Qty: module.duration,
      Price: module.price,
    };

    const index = cart.value.findIndex(i => i.moduleid === newItem.moduleid);

    if (index !== -1) {
      // update quantity
      cart.value[index].Qty = newItem.Qty;
    } else {
      // push new item
      cart.value.push(newItem);
    }

    save();
  };

  // Update only quantity
  const updateQty = (id, newQty) => {
    const item = cart.value.find(i => i.moduleid === id);
    if (item) {
      item.Qty = Number(newQty);
      save();
    }
  };

  // Update item properties (edit module)
  const updateItem = (id, payload) => {
    const item = cart.value.find(i => i.moduleid === id);
    if (item) {
      Object.assign(item, payload); // merge updated fields
      save();
    }
  };

  // Delete item by ID
  const deleteItem = (id) => {
    cart.value = cart.value.filter(i => i.moduleid !== id);
    save();
  };

  // Save to localStorage
  const save = () => {
    localStorage.setItem("moduleCart", JSON.stringify(cart.value));
  };

  return {
    cart,
    itemCount,
    loadCart,
    addToCart,
    updateQty,
    updateItem,
    deleteItem,
  };
}
